import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth/authStore';

export function RoleRouter() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  return (
    <Navigate to={user.role === 'SUPER_ADMIN' ? '/app/super/overview' : '/app/org/overview'} replace />
  );
}
